import type { ReportReason, ReportStatus, ReportTargetType } from "api/types/report.types";
import type { TabItem } from "components/UI/Tabs";

export type BadgeVariant = "active" | "pending" | "rejected" | "draft" | "default" | "info";

export const PAGE_SIZE = 20;

export const REPORT_TABS: TabItem[] = [
  { key: "all", label: "전체" },
  { key: "pending", label: "대기" },
  { key: "reviewing", label: "검토 중" },
  { key: "resolved", label: "처리 완료" },
  { key: "dismissed", label: "기각" },
];

export const STATUS_BADGE: Record<ReportStatus, BadgeVariant> = {
  pending: "pending",
  reviewing: "info",
  resolved: "active",
  dismissed: "draft",
};

export const STATUS_LABEL: Record<ReportStatus, string> = {
  pending: "대기",
  reviewing: "검토 중",
  resolved: "처리 완료",
  dismissed: "기각",
};

export const REASON_LABEL: Record<ReportReason, string> = {
  spam: "스팸",
  harassment: "괴롭힘",
  hate_speech: "혐오 발언",
  violence: "폭력",
  inappropriate: "부적절한 콘텐츠",
  other: "기타",
};

export const TARGET_TYPE_LABEL: Record<ReportTargetType, string> = {
  post: "게시글",
  comment: "댓글",
  user: "사용자",
};

export const TARGET_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "대상 유형 전체" },
  { value: "post", label: "게시글" },
  { value: "comment", label: "댓글" },
  { value: "user", label: "사용자" },
];
